import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationModels } from 'models/configuration.models';
import { Observable } from 'rxjs';
import { Signature } from '../../components/Souscriptions/models/Signature.model';
import { Assurees } from '../../components/Souscriptions/models/Assurees.model';
import { Paiement } from '../../components/Souscriptions/models/Paiement.model';
import { Souscription } from '../../components/Souscriptions/models/Souscription.model';
import { TarifViewModel } from '../../components/Souscriptions/models/tarif-view-model.model';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class SouscriptionEnLigneApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'souscriptionsenligne');
  }

  BeginSubscription(request: Souscription): Observable<any> {
    return this.post('/SetFicheSouscriptionDebut', this.encryptData(request));
  }

  getEtapeAdhesion(request: Guid_Mdp) {
    return this.httpClient.get('/GetEtapeAdhesion/' + request);
  }

  setFicheAdhesion(request: Assurees): Observable<any> {
    return this.post('/setFicheAdhesion', this.encryptData(request));
  }

  setFicheAdhesionFromUrl(request: Assurees): Observable<any> {
    return this.post('/SetFicheAdhesionFromUrl', this.encryptData(request));
  }

  getFicheAdhesion(): Observable<Guid_Mdp[]> {
    return this.getFicheAdhesionGuid('/getFicheAdhesion');
  }
  getFicheAdhesionInstance(): Observable<Guid_Mdp[]> {
    return this.getFicheAdhesionGuidInstance('/getFicheAdhesionInstance');
  }

  getSiteSouscrire(tokenTurnstile: string) {
    return this.getSiteSouscription('/getSiteSouscription/' + tokenTurnstile);
  }

  getSiteSouscrireInstance() {
    return this.getSiteSouscriptionInstance('/getFicheSouscriptionInstance');
  }
  getFicheSouscription() {
    return this.getFicheSubscribe('/getFicheSouscription');
  }
  SetFicheAdhesionPaiement(request: Paiement): Observable<any> {
    return this.post('/SetFicheAdhesionPaiement', this.encryptData(request));
  }
  //GetStep3
  getFicheAdhesionPaiement() {
    // return this.post('/GetFicheAdhesionPaiement', request);
    return this.getAdhesionPaiement('/getFicheAdhesionPaiement');
  }
  getFicheAdhesionPaiementInstance() {
    // return this.post('/GetFicheAdhesionPaiement', request);
    return this.getAdhesionPaiementInstance(
      '/getFicheAdhesionPaiementInstance',
    );
  }
  SetFicheAdhesionTarif(request: TarifViewModel): Observable<any> {
    return this.post('/SetFicheAdhesionTarif', this.encryptData(request));
  }
  //GetStep2
  getFicheAdhesionTarif() {
    return this.getAdhesionTarif('/getFicheAdhesionTarif');
  }
  //GetStep2
  getFicheAdhesionTarifInstance() {
    return this.httpGetAdhesionTarifInstance('/getFicheAdhesionTarifInstance');
  }

  GetCodeSignature(request: Signature): Observable<any> {
    return this.post('/GetCodeSignature', this.encryptData(request));
  }

  GetAdhesionDoc(): Observable<any> {
    return this.getAdhesionPDF('/getAdhesionDoc');
    // return this.getAdhesionPDF('/getAdhesionDoc/' + "491ED126-A019-4659-9281-1BE9714F4BCD" + "/" + "05DD42FA94B71296A9EEDDC25691033D");
  }

  VerifierCodeSignature(request: Signature): Observable<any> {
    return this.post('/VerifierCodeSignature', this.encryptData(request));
  }
  getAdhesionDocument() {
    return this.httpClient.get('/getAdhesionDocument/');
  }
  getAdhesionDocumentSignature(): Observable<any> {
    return this.getAdhesionDocSignature('/getAdhesionDocumentSigne');
  }
  getDocumentLettreBienvenue(): Observable<any> {
    return this.getAdhesionDocSignature('/getLettreBienvenue');
  }

  getDocumentUrlFraisGestion(): Observable<any> {
    return this.getDocFraisGestion('/getDocumentUrlFraisGestion');
  }

  getDetailsCotisation(
    codeGamme: string,
    codeFormule: string,
  ): Observable<any> {
    return this.getDetailsCotis(
      '/getDetailsCotisation?codeGamme=' +
        codeGamme +
        '&codeFormule=' +
        codeFormule,
    );
  }
}

interface Guid_Mdp {
  guid: string;
  mdp: string;
}
